import { render, staticRenderFns } from "./ModalModificaProgetto.vue?vue&type=template&id=e6439348&"
import script from "./ModalModificaProgetto.vue?vue&type=script&lang=js&"
export * from "./ModalModificaProgetto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports